export const getDataHighlights = (data, dataKey) => {
  const currentIndex = data.length - 1;
  let minIndex = -1;
  let maxIndex = -1;
  let minValue = 0;
  let maxValue = 0;

  if (currentIndex >= 0) {
    minIndex = 0;
    maxIndex = 0;

    for (let index = 1; index <= currentIndex; index += 1) {
      if (data[index][dataKey] < data[minIndex][dataKey]) {
        minIndex = index;
      }

      if (data[index][dataKey] > data[maxIndex][dataKey]) {
        maxIndex = index;
      }
    }
  }

  if (minIndex > -1) {
    minValue = data[minIndex][dataKey];
  }

  if (maxIndex > -1) {
    maxValue = data[maxIndex][dataKey];
  }

  // For constant chart (all points at same value) there is no min or max highlights.
  if (minIndex === maxIndex) {
    minIndex = -1;
    maxIndex = -1;
  }

  return {
    currentIndex,
    minIndex,
    maxIndex,
    minValue,
    maxValue,
  };
};

export const getAverage = (points, dataKey) => {
  const sum = points.reduce((accumulator, point) => accumulator + point[dataKey], 0);

  return sum / points.length;
};
